import { render, staticRenderFns } from "./loaderFullscreen.vue?vue&type=template&id=6fb8018b&scoped=true"
import script from "./loaderFullscreen.vue?vue&type=script&lang=js"
export * from "./loaderFullscreen.vue?vue&type=script&lang=js"
import style0 from "./loaderFullscreen.vue?vue&type=style&index=0&id=6fb8018b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8018b",
  null
  
)

export default component.exports